<template>
    <div class="talRecordBox">
        <!-- 左侧列表 -->
        <div class="tal-left">
            <div class="hw-banner" :class="conneClass">
                <span class="hw-dot"></span>
                <span class="hw-text" v-if="callloading">正在连接来电设备…</span>
                <span class="hw-text" v-else-if="$global.isJDTelMonitor">来电设备已联通</span>
                <span class="hw-text" v-else>来电设备未联通，无法接收来电信息</span>
                <div class="hw-reconnect" @click="callMonitorOpen()" v-show="!$global.isJDTelMonitor && !callloading">
                    <i class="iconfont icon-zhongxin"></i>
                    重新连接
                </div>
            </div>
            <div class="tal-filter-nav">
                <span class="tal-nav-item" :class="{selected: talFilterType==0}" @click="talFilterType=0">全部</span>
                <span class="tal-nav-item" :class="{selected: talFilterType==2}" @click="talFilterType=2">已读</span>
                <span class="tal-nav-item" :class="{selected: talFilterType==1}" @click="talFilterType=1">未读</span>
            </div>
            <div class="search-row">
                <div class="tal-search-box">
                    <input type="text" v-model="talSearchText" placeholder="输入电话号码检索" class="tal-search-input"/>
                    <i class="iconfont icon-dianhua1"></i>
                </div>
                <div class="btn-read-all" @click="readAll()" v-if="talFilterType!=2">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                    全部已读
                </div>
            </div>
            <div class="tal-left-list">
                <div class="tal-list-item" 
                    v-for="item in filteredCallRecords" :key="item"
                    :class="{selected: talRecordInfo?.TelAutoID == item.TelAutoID,unread:item.LogStatus==0}"
                    @click="selectTalRecord(item)">
                    <div class="icon">
                        <i class="iconfont icon-dianhua11"></i>
                    </div>
                    <div class="tal-li-header">
                        <div class="tal-li-phone-row">
                            <div class="tal-li-phone">{{$global.phonePrivacy(item.Telnum)}}</div>
                            <span class="call-status-tag unread-tag" v-if="item._LogStatus==0">未读</span>
                            <span class="call-status-tag read-tag" v-else-if="item._LogStatus==1">已读</span>
                            <span class="call-status-tag converted-tag" v-else>已转预订单</span>
                        </div>
                        <div class="tal-li-time">{{formatter(item.CreatTime)}}</div>
                    </div>
                </div>
                <div class="tal-empty" v-if="filteredCallRecords.length === 0">暂无来电记录</div>
            </div>
        </div>
        <!-- 右侧详情 -->
        <div class="tal-right">
            <div class="tal-detail" v-if="talRecordInfo">
                <div class="detail-header">
                    <div class="title">来电详情</div>
                    <span class="detail-status unread-tag" v-if="talRecordInfo.LogStatus==0">未读</span>
                    <span class="detail-status read-tag" v-else-if="talRecordInfo.LogStatus==1">已读</span>
                    <span class="detail-status converted-tag" v-else>已转预订单</span>
                </div> 
            
                <div class="tal-detail-body">
                    <div class="info-card">
                        <div class="info-card-title">来电信息</div>
                        <div class="info-row">
                            <span class="info-label">电话号码</span>
                            <span class="info-value">{{$global.phonePrivacy(talRecordInfo.Telnum)}}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">来电时间</span>
                            <span class="info-value">{{formatter(talRecordInfo.CreatTime)}}</span>
                        </div>
                    </div>
                    <div class="converted-card" v-if="talRecordInfo.OrderInfo">
                        <div class="converted-card-title">
                            <i class="iconfont icon-wanchenggouxuanxuanzhong"></i>已转预订单
                        </div>
                        <div class="converted-link" >
                            <span>{{talRecordInfo.OrderInfo.Eat_OrderNo}}</span> 
                            <i class="iconfont icon-fenxiang"></i>
                        </div>
                        <div class="converted-meta">{{talRecordInfo.OrderInfo.ReserveDesks[0].Eat_DeskName}} · 创建于 {{formatter(talRecordInfo.OrderInfo.CreatTime)}}</div>
                    </div>

                    <div class="match-card" v-if="talRecordInfo.CstmInfo">
                        <div class="match-card-title">
                            <i class="iconfont icon-yonghu1"></i>
                            匹配到客户信息
                        </div>
                        <div class="match-row">姓名：<b>{{talRecordInfo.CstmInfo.Cstm_Name}}先生</b> <span class="tag_vip" v-if="talRecordInfo.CstmInfo.IsVIP">VIP</span></div>
                        <div class="match-row">最近到店：<b>{{dateFormat(talRecordInfo.CstmInfo.LastTime)}}</b></div>
                        <div class="match-row">客户喜好：<b>{{clientLike}}</b></div>
                        
                        <div class="consume-bar">
                            <div class="consume-item">
                                <div class="c-val">{{talRecordInfo.CstmInfo.TotalNum}}<span class="c-unit">次</span></div>
                                <div class="c-label">近30天消费</div>
                            </div>
                            <div class="consume-item">
                                <div class="c-val">{{talRecordInfo.CstmInfo.DeskAvgMoney}}<span class="c-unit">元</span></div>
                                <div class="c-label">桌均</div>
                            </div>
                            <div class="consume-item">
                                <div class="c-val">{{talRecordInfo.CstmInfo.ManAvgMoney}}<span class="c-unit">元</span></div>
                                <div class="c-label">人均</div>
                            </div>
                        </div>
                    </div>

                    <div class="history-section" v-if="talRecordInfo.RecentTelList?.length>0">
                        <div class="history-title">
                            近30天来电历史
                            <span class="history-count">共 {{talRecordInfo.RecentTelList.length}} 条</span>
                        </div>
                        <div class="history-list">
                            <div class="history-item" v-for="item in talRecordInfo.RecentTelList" :key="item">
                                <span class="h-time">{{formatter(item.CreatTime)}}</span>
                                <span class="h-store">{{item.Department_Name}}</span>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="tal-detail-actions">
                    <div class="tal-btn" @click="clickOrder()"><i class="iconfont icon-tianjia1"></i>去创建预订单</div>
                </div>
            </div>
            <div class="tal-detail-empty" v-else>
                <i class="iconfont icon-dianhua11"></i>
                <div class="text">请选择一条来电记录查看详情</div>
            </div>
        </div>
    </div>
</template>

<script>
//电话记录
export default {
    data(){
        return {
            //开启电话监听 中
            callloading:false,
            //来电记录列表
            callRecords:[],
            //来电记录筛选 0全部 1未读 2已读 
            talFilterType: 1, 
            talSearchText: '',
            //选中的记录
            talRecordInfo:null,
        }
    },
    computed:{
        //筛选来电记录
        filteredCallRecords(){
            let list = this.callRecords||[];
            if(this.talFilterType ==1){//未读  0=未读 1=已读2=已转预订单
                list = list.filter(item => item.LogStatus === 0);
            }else if(this.talFilterType ==2){//已读
                list = list.filter(item => item.LogStatus != 0);
            }
            if(this.talSearchText.trim()){
                const text = this.talSearchText.trim().toLowerCase();
                list = list.filter(item => (item.Telnum && item.Telnum.toLowerCase().indexOf(text) > -1) );
            }
            //排序
            list.sort((d1,d2)=>{
                if(d1._LogStatus==0 && d2._LogStatus!=0){
                    return -1;
                }else if(d1._LogStatus!=0 && d2._LogStatus==0){
                    return 1;
                }
                
                return new Date(d2.CreatTime).getTime()-new Date(d1.CreatTime).getTime();//倒叙
            })

            return list;
        },
        //未读数量
        notReadCount(){
            return (this.callRecords||[]).filter(it=>it._LogStatus == 0).length;
        },
        //连接状态 类名
        conneClass(){
            if(this.callloading){
                return "connecting";
            }else if(this.$global.isJDTelMonitor){
                return "connected";
            }
            return "disconnected";
        },
        //客户喜好
        clientLike(){
            if(this.talRecordInfo?.CstmInfo){
                return this.talRecordInfo.CstmInfo.ClientLableList?.filter(it=>it.LableType==1).map(it=>it.LableName).join(",");
            }
            return "";
        }
    },
    watch:{
        //有新的电话记录
        "$global.newJDTelList.length"(){
            if(this.$global.newJDTelList?.length>0){
                this.$global.newJDTelList.forEach(it=>{
                    if(!this.callRecords.some(item=>item.TelAutoID==it.TelAutoID)){
                        it._LogStatus=it.LogStatus;
                        this.callRecords.unshift(it);
                    }
                });
                //没有 其它操作 没有弹层
                if(this.$parent.editDeskType==0 && !this.$parent.isReserveEdit && !this.$parent.$refs.reason.visible){
                    let time=new Date().getTime()-this._eventTime
                    if(time>5 * 60 * 1000){//5分钟未操作
                        this.$parent.navIndex=1;
                        if(this.talFilterType==2){
                            this.talFilterType=1;
                        }
                        this.selectTalRecord(this.filteredCallRecords[0]);
                    }
                }
            }
            this.$global.newJDTelList=[];
        },
        talFilterType(){
            this.callRecords?.forEach(it=>{
                it.LogStatus=it._LogStatus;
            })
        }
    },
    mounted(){
        document.addEventListener("click",this.eventFun);
        document.addEventListener("keydown",this.eventFun);
        document.addEventListener("mousemove",this.eventFun);
        document.addEventListener("mousewheel",this.eventFun);
        document.addEventListener("touchstart",this.eventFun);
        document.addEventListener("touchmove",this.eventFunn);
        document.addEventListener("touchend",this.eventFun);
    },
    beforeUnmount(){//被卸载前调用
        document.removeEventListener("click",this.eventFun);
        document.removeEventListener("keydown",this.eventFun);
        document.removeEventListener("mousemove",this.eventFun);
        document.removeEventListener("mousewheel",this.eventFun);
        document.removeEventListener("touchstart",this.eventFun);
        document.removeEventListener("touchmove",this.eventFun);
        document.removeEventListener("touchend",this.eventFun);
    },
    methods:{
        //默认未读
        defaultNotRead(){
            this.talFilterType=1;
            this.talRecordInfo=null;
            if(this.filteredCallRecords.length>0){
                this.selectTalRecord(this.filteredCallRecords[0]);
            }
        },
        //有电话数据推送过来
        telUpdate(list){
            list?.forEach(it=>{
                let info=this.callRecords.find(item=>item.TelAutoID==it.TelAutoID);
                if(info){
                    it._LogStatus=it.LogStatus;
                    Object.assign(info,it);
                }else{
                    this.$global.newJDTelList.push(it);
                }
            })
        },
        //操作 事件 触发
        eventFun(){
            this._eventTime=new Date().getTime();
        },
        /*时间格式 */
        formatter(cellValue) {
            if(!cellValue || cellValue=='0001-01-01T00:00:00'){
                return '';
            }
            return (new Date(cellValue)).Format('yyyy-MM-dd hh:mm');
        },
        dateFormat(cellValue){
            if(!cellValue || cellValue=='0001-01-01T00:00:00' || cellValue=='1900-01-01T00:00:00'){
                return '';
            }
            return (new Date(cellValue)).Format('yyyy-MM-dd');
        },
        //开启 电话监听
        callMonitorOpen(){
            this.callloading=true;//连接中
            this.$webBrowser.getTalRecordConfig().then(d=>{//获取电显示
				if(d && d.isEnableTalRecord){
                    this.$webBrowser.callMonitorOpen(d.type,d.name).then(d=>{
                        this.callloading=false;
                        if(d && (d.status==0 || d.state==0)){
                            this.$global.isJDTelMonitor=true;
                            console.log("电话监听开启");
                        }else{
                            this.$message.error("来电设备连接失败:"+(d?.message||""));
                        }
                    })
                }else{
                    this.$alert("未开启来电显示功能,请先去配置");
                    this.callloading=false;//连接中
                }
            });
        },
        /**选中来电记录 */
        selectTalRecord(item){
            if(this.talRecordInfo?.TelAutoID!=item.TelAutoID){
                this.talRecordInfo = item;
                this.loadTelInfoDetail(item);
            }
        },
        /**创建预订单 */
        clickOrder(){
            if(this.talRecordInfo){
                this.$parent.clickOrder(this.talRecordInfo);
            }
        },
        async loadList(isLoading){
            if(this._load){
                return;
            }
            this._load=true;
            let loading; 
            if(isLoading){
                loading = this.$loading({
                    text: "请求中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
            }
            const param={};
            await this.$httpAES.reservePost("Bestech.CloudPos.Reserve.GetDtReserveTelList", param).then(d => {
                this._load=false;
                if(isLoading){
                    loading.close();
                }
                if (d.ResponseHeader.ResultCode != 0) {
                    if (!isLoading) {
                        throw {
                            message: d.ResponseHeader.ResultDesc
                        };
                    }
                    this.$message.error(d.ResponseHeader.ResultDesc);
                } else {
                    this.callRecords=d.ResponseBody||[];
                    this.callRecords.forEach(it=>{
                        it._LogStatus=it.LogStatus;
                    })
                    this.talRecordInfo=null;
                }
            }).catch(e => {
                this._load=false;
                if (!isLoading) {
                    throw e;
                }
                loading.close();
                this.$message.error(e.message);
                console.log('请求失败:', e);
            });
        },
        //加载明细数据
        loadTelInfoDetail(item){
            if(!item){
                return;
            }
            if(this._load){
                return;
            }
            this._load=true;
            
            const loading = this.$loading({
                text: "请求中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            const param={
                TelAutoID:item.TelAutoID
            };
            this.$httpAES.reservePost("Bestech.CloudPos.Reserve.GetReserveTelInfoDetail", param).then(d => {
                this._load=false;
                loading.close();
                if (d.ResponseHeader.ResultCode != 0) {
                    this.$message.error(d.ResponseHeader.ResultDesc);
                } else {
                    this.talRecordInfo=d.ResponseBody;
                    if(d.ResponseBody){
                        let info=this.callRecords.find(it=>it.TelAutoID==item.TelAutoID);
                        if(info){
                            info._LogStatus=d.ResponseBody.LogStatus;
                        }
                    }
                    
                }
            }).catch(e => {
                this._load=false;
                loading.close();
                this.$message.error(e.message);
                console.log('请求失败:', e);
            });
        },
        //重新加载明细数据
        refreshInfoDetail(){
            if(this.talRecordInfo){
                this.loadTelInfoDetail(this.talRecordInfo);
            }
        },//全部已读
        readAll(){
            let list=(this.callRecords||[]).filter(it=>it.LogStatus == 0);
            if(list.length==0){
                this.$message.warning("没有未读记录!");
                return;
            }
            this.$confirm("是否确定将当前未读记录标记为已读?", '提示', {
                confirmButtonText: "确定",
				cancelButtonText:"取消",
				callback: (name) => {
					if(name=='confirm'){
						this.AllReadReserveTelInfo(list);
					}
				},
            })
        },
        //标记为已读
        AllReadReserveTelInfo(list){
            const loading = this.$loading({
                text: "请求中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            const param={
                TelAutoIDs:list.map(it=>it.TelAutoID)
            };
            this.$httpAES.reservePost("Bestech.CloudPos.Reserve.AllReadReserveTelInfo", param).then(d => {
                this._load=false;
                loading.close();
                if (d.ResponseHeader.ResultCode != 0) {
                    this.$message.error(d.ResponseHeader.ResultDesc);
                } else {
                    list.forEach(it=>{
                        it._LogStatus=it.LogStatus=1;
                    })
                }
            }).catch(e => {
                this._load=false;
                loading.close();
                this.$message.error(e.message);
                console.log('请求失败:', e);
            });
        }
    }
}
</script>

<style lang="scss">
@import './talRecordBox.scss'
</style>